export default __webpack_public_path__ + "static/media/main-car.b07f3e1b.webp";